import React, {useState, useEffect} from 'react';
import './Classement.css'
import {getLongNameChamp, classementAPI, listClubProam, listClubProbm, listClubProad, listClubProbd} from '../variables';

import axios from 'axios';
import LogoClub from '../components/LogoClub';
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

var XMLParser = require('react-xml-parser');


function Classement({championnat}) {
    const [classement, setClassement] = useState(null);

    useEffect(() => {
        getClassement()
    }, [championnat])

    const getClassement = async () => {
        const link = classementAPI.find(item => item.for == championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = new XMLParser().parseFromString(res.data).children;
                // Trier les données par la position
                data.sort((a, b) => {
                    return a.getElementsByTagName('clt')[0].value - b.getElementsByTagName('clt')[0].value;
                });
                setClassement(data);
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const info = (index, value) => {
        return classement[index].getElementsByTagName(value)[0].value;
    }

    const getCorrectListClub = (value) => {
        switch (value) {
            case 'proam':
                return listClubProam;
            case 'probm':
                return listClubProbm;
            case 'proad':
                return listClubProad;
            case 'probd':
                return listClubProbd;
            default:
                break;
        }
    }

    const getClub = (index) => {
        const identifier = info(index, 'numero');
        const title = info(index, 'equipe');
        const champ = getCorrectListClub(championnat) || null;

        if (champ !== null) {
            return champ.find(item => item.identifier === identifier || item.title.trim() === title.trim());
        }

        return "";
    }

    const getTotalMonter = () => {
        switch (championnat) {
            case 'probm':
                return 1;
            case 'proad':
                return 1;
            case 'probd':
                return 1;
            default:
                return 0;
                break;
        }
    }

    const getTotalDescente = () => {
        switch (championnat) {
            case 'proam':
                return 2;
            case 'probm':
                return 2;
            case 'proad':
                return 2;
            case 'probd':
                return 0;
            default:
                return 0;
                break;
        }
    }

    const getPositionClass = (index, length) => {
        switch (championnat) {
            case 'proam': /* Pro A Messieurs */
                if (index < 2) return 'montee';
                return '';
            case 'proad': /* Pro A Dames */
                if (index < 6) return 'montee';
                if (index >= length - 6) return 'descente';
                return '';
            case 'probm': /* Pro B Messieurs */
                if (index < 6) return 'montee';
                if (index >= length - 6) return 'descente';
                return '';
            case 'probd': /* Pro B Dames */
                if (index === 0) return 'montee';
                if (index === length - 1) return 'descente';
                return '';
            
            
            
            default:
                return '';
        }
    }

    return ( 
        <div className="classement_page">

            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                {
                    championnat == 'proam' &&
                        <span>
                            <img src={logoProAM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'proad' &&
                        <span>
                            <img src={logoProAD} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probm' &&
                        <span>
                            <img src={logoProBM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probd' &&
                        <span>
                            <img src={logoProBD} alt="Logo pro" className="logo_p" />
                        </span>
                }  
                <span className="top_banniere_title">
                    Classement {getLongNameChamp(championnat)}
                </span>
            </div>

            <div className="classement_content">
                <table className="classement_table" cellPadding={0} style={{borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{backgroundColor: 'white', fontWeight: 'bold'}}>
                            <td id="pos">POS</td>
                            <td id="clClub">CLUBS</td>
                            <td>PTS</td>
                            <td>MJ</td>
                            <td>VIC</td>
                            <td>NUL</td>
                            <td>DEF</td>
                            <td id="FF">FF/P</td>
                            <td id="PG">PG</td>
                            <td id="PP">PP</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            classement !== null &&
                            classement.map((item, index) => {
                                return (
                                    <tr key={info(index, 'numero')} style={{width: '100%', backgroundColor: 'white'}}>
                                        <td style={{display: 'flex', alignItems: 'center', gap: 15}}>
                                            <div className={`classement_color ${getPositionClass(index, classement.length)}`}></div>
                                            <span>{info(index, 'clt')}</span>
                                            <span style={{paddingRight: 25}}>-</span>
                                        </td>
                                        <td>
                                            <div style={{display: 'flex', alignItems: 'center', gap: 15}} >
                                                <div className="cl_logo">
                                                    <LogoClub className="cl_logo" club={getClub(index)} width="32" height="32" activateLink={false}  />
                                                </div>
                                                <span className="classement_club">{info(index, 'equipe')}</span>
                                            </div>
                                        </td>
                                        <td className="classement_scores">
                                            <span>{info(index, 'pts')}</span>
                                        </td>
                                        <td className="classement_scores">
                                            <span>{info(index, 'joue')}</span>
                                        </td>
                                        <td className="classement_scores">
                                            <span>{info(index, 'vic')}</span>
                                        </td>
                                        <td className="classement_scores">
                                            <span>{info(index, 'nul')}</span>
                                        </td>
                                        <td className="classement_scores">
                                            <span>{info(index, 'def')}</span>
                                        </td>
                                        <td id="FF" className="classement_scores">
                                            <span>{info(index, 'pf')}</span>
                                        </td>
                                        <td id="PG" className="classement_scores">
                                            <span>{info(index, 'pg')}</span>
                                        </td>
                                        <td id="PP" className="classement_scores">
                                            <span>{info(index, 'pp')}</span>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <div className="legend">
                    <div className="legend_title">Légende</div>
                    <div className="legend_item">
                        <div className="classement_color montee"></div>
                        <span>{championnat === 'probd' ? 'Montée' : 'Playoffs'}</span>
                    </div>
                    <div className="legend_item">
                        <div className="classement_color descente"></div>
                        <span>{championnat === 'probd' ? 'Descente' : 'Playdown'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Classement;